<div class="ui static form">
    <div class="inline field">
        <label>{{ 'document.uploadedBy' | translate }}</label>
        {{ document.file?.uploadedBy?.fullName }}
    </div>
    <div class="inline field">
        <label>{{ 'document.dateUploaded' | translate }}</label>
        {{ document.createdAt | appDate }}
    </div>
    <div class="inline field">
        <label>{{ 'document.modified' | translate }}</label>
        {{ document.updatedAt | appDate }}
    </div>
</div>
